<template>
  <div id="one_view_form">

    <div v-if="person_details && person_details.istemplateApplicable === true">
      <span v-html="person_details.output"></span>
      <div class="text-center no-print mt-4">
        <v-btn tile outlined color="primary" @click="print()">
          <v-icon left>mdi-printer</v-icon> Print Form
        </v-btn>
      </div>
    </div>

    <div v-else class="form-wrapper">

      <div class="print-page">

        <div class="header-wrapper">
          <div class="header-top-text">
              <div class="app-session">Session {{ person_details.ay || '2026-27' }}</div>
          </div>
          
          <table class="header-table">
            <tr>
              <td class="header-logo-cell">
                <img
                  v-if="person_details.rep_header && person_details.rep_header.school_logo"
                  :src="person_details.rep_header.school_logo"
                  alt="logo"
                  class="college-logo"
                />
              </td>

              <td class="header-info-cell">
                <h1 class="college-name">
                  {{ person_details.rep_header ? person_details.rep_header.school_name : '' }}
                </h1>
                <div class="college-address"> <b>
                  {{ person_details.rep_header ? person_details.rep_header.address : '' }}
                  </b>
                </div>
              </td>

              <td class="header-app-cell">
                <div class="app-title">Application for Admission to</div>
                <div class="app-standard">{{ person_details.standard ? person_details.standard.field_value : '' }}</div>
                <div class="app-session"><b>Session {{ person_details.ay || '2026-27' }}</b></div>
                <div class="app-no"> <b>Application No.:{{ person_details.admission_form_no }}</b></div>
              </td>

              <td class="header-photo-cell">
                <img
                  v-if="person_details.profile_image_name"
                  :src="awspath + (person_details.profile_image_path || '') + person_details.profile_image_name"
                  alt="Student"
                  class="student-photo"
                />
                <div v-else class="photo-placeholder">Photo</div>

                <img
                  v-if="person_details.student_sign"
                  :src="awspath + person_details.student_sign"
                  alt="Signature"
                  class="student-signature"
                  style="width: 100%; height: 30px;"
                />
              </td>
            </tr>
          </table>
        </div>

        <div class="section-block">
          <div class="section-title">Applicant's Personal Details</div>
          <table class="form-table">
            <tr>
              <td class="label-cell" style="width:20%">Name of the Student</td>
              <td class="value-cell text-center" style="width:26%">
                <b>{{ person_details.lastname ? person_details.lastname.field_value : '' }}</b>
              </td>
              <td class="value-cell text-center" style="width:26%">
                <b>{{ person_details.firstname ? person_details.firstname.field_value : '' }}</b>
              </td>
              <td class="value-cell text-center" style="width:28%">
                <div class="split-cell">
                  <span><b>{{ person_details.middlename ? person_details.middlename.field_value : '' }}</b></span>
                  <span><b>{{ person_details.mother_first_name ? person_details.mother_first_name.field_value : '' }}</b></span>
                </div>
              </td>
            </tr>
            <tr class="sub-label-row">
              <td class="label-cell"></td>
              <td class="sub-label">Surname</td>
              <td class="sub-label">First name</td>
              <td class="sub-label">
                <div class="split-cell">
                  <span>Father name</span>
                  <span>Mother's Name</span>
                </div>
              </td>
            </tr>
          </table>

          <table class="form-table details-table" style="border-top: none;">
            <tr>
              <td class="label-cell width-15">Date of Birth</td>
              <td class="value-cell width-35">{{ person_details.date_of_birth ? person_details.date_of_birth.field_value : '' }}</td>
              <td class="label-cell width-15">Place Of Birth</td>
              <td class="value-cell width-35">{{ person_details.birth_place ? person_details.birth_place.field_value : '' }}</td>
            </tr>
            <tr>
              <td class="label-cell">Birth State</td>
              <td class="value-cell">{{ person_details.birthstate ? person_details.birthstate.field_value : '' }}</td>
              <td class="label-cell">Birth District</td>
              <td class="value-cell">{{ person_details.birthdistrict ? person_details.birthdistrict.field_value : '' }}</td>
            </tr>
            <tr>
              <td class="label-cell">Birth Tehsil</td>
              <td class="value-cell">{{ person_details.birthdistrict ? person_details.birthtaluka.field_value : '' }}</td>
              <td class="label-cell">Eligibility No.</td>
              <td class="value-cell">{{ person_details.eligibility_no ? person_details.eligibility_no.field_value : '' }}</td>
            </tr>
            <tr>
              <td class="label-cell">Marital Status</td>
              <td class="value-cell">{{ person_details.marital_status ? person_details.marital_status.field_value : '' }}</td>
              <td class="label-cell">Blood Group</td>
              <td class="value-cell">{{ person_details.bloodgroup ? person_details.bloodgroup.field_value : '' }}</td>
            </tr>
            <tr>
              <td class="label-cell">Religion</td>
              <td class="value-cell">{{ person_details.religion ? person_details.religion.field_value : '' }}</td>
              <td class="label-cell">Gender</td>
              <td class="value-cell">{{ person_details.gender ? person_details.gender.field_value : '' }}</td>
            </tr>
            <tr>
              <td class="label-cell">Nationality</td>
              <td class="value-cell">{{ person_details.nationality ? person_details.nationality.field_value : '' }}</td>
              <td class="label-cell">Aadhar card Number</td>
              <td class="value-cell">{{ person_details.aadhar_no ? person_details.aadhar_no.field_value : '' }}</td>
            </tr>
            <tr>
              <td class="label-cell">Mother Tongue</td>
              <td class="value-cell">{{ person_details.mothertoungue ? person_details.mothertoungue.field_value : '' }}</td>
              <td class="label-cell">Is Orphan</td>
              <td class="value-cell">{{ person_details.is_orphan ? person_details.is_orphan.field_value : 'No' }}</td>
            </tr>
            <tr>
              <td class="label-cell">Caste Category</td>
              <td class="value-cell">{{ person_details.category ? person_details.category.field_value : '' }}</td>
              <td class="label-cell">Sub Caste</td>
              <td class="value-cell">{{ person_details.sub_caste ? person_details.sub_caste.field_value : '' }}</td>
            </tr>
            <tr>
              <td class="label-cell">Handicap</td>
              <td class="value-cell">{{ person_details.isphysicallyhandicapped ? person_details.isphysicallyhandicapped.field_value : '' }}</td>
              <td class="label-cell">Saral No.</td>
              <td class="value-cell">{{ person_details.saral_id ? person_details.saral_id.field_value : '' }}</td>
            </tr>
            <tr>
              <td class="label-cell">Height</td>
              <td class="value-cell">{{ person_details.height ? person_details.height.field_value : '' }}</td>
              <td class="label-cell">Weight</td>
              <td class="value-cell">{{ person_details.weight ? person_details.weight.field_value : '' }}</td>
            </tr>
          </table>
        </div>

        <div class="section-block">
          <div class="section-title">Scholarship</div>

          <table class="form-table details-table">
            <tr>
              <td
                class="value-cell text-center"
                colspan="4"
                style="padding: 8px;"
              >
                <b>
                  {{
                    person_details.scholarship &&
                    person_details.scholarship.field_value
                      ? person_details.scholarship.field_value
                      : 'No Scholarship Required'
                  }}
                </b>
              </td>
            </tr>
          </table>
        </div>

        <div class="section-block">
          <table class="form-table details-table">
            <tr>
              <td class="label-cell width-20">Father's/Husband's Name</td>
              <td class="value-cell" colspan="3">
                {{ person_details.relative_father_details ? person_details.relative_father_details.relative_full_name : '' }}
              </td>
            </tr>
            <tr>
              <td class="label-cell">Occupation</td>
              <td class="value-cell width-30">
                {{ person_details.relative_father_details ? person_details.relative_father_details.relative_occupation : '' }}
              </td>
              <td class="label-cell width-20">Gross Annual Income</td>
              <td class="value-cell width-30">
                {{ person_details.relative_father_details ? person_details.relative_father_details.relative_income : '0' }}
              </td>
            </tr>
            <tr>
              <td class="label-cell">Mobile</td>
              <td class="value-cell" colspan="3">
                {{ person_details.relative_father_details ? person_details.relative_father_details.relative_contact_no : '' }}
              </td>
            </tr>
          </table>
        </div>

        <div class="section-block">
          <div class="section-title">Address of Correspondence</div>
          <table class="form-table details-table">
            <tr>
              <td class="label-cell width-20">Address</td>
              <td class="value-cell" colspan="3">
                {{ person_details.local_address ? person_details.local_address.laddress : '' }}
              </td>
            </tr>
            <tr>
              <td class="label-cell">State</td>
              <td class="value-cell">{{ person_details.local_address ? person_details.local_address.lstate : ''}}</td>
              <td class="label-cell">District</td>
              <td class="value-cell">{{ person_details.local_address ? person_details.local_address.ldistrict : ''}}</td>
            </tr>
            <tr>
              <td class="label-cell">City/Town/Village</td>
              <td class="value-cell">{{person_details.local_address ? person_details.local_address.lcity : '' }}</td>
              <td class="label-cell">Pincode</td>
              <td class="value-cell">{{ person_details.local_address ? person_details.local_address.lpin : ''}}</td>
            </tr>
          </table>
        </div>

        <div class="section-block">
          <div class="section-title">Permanent/Native Address</div>
          <table class="form-table details-table">
            <tr>
              <td class="label-cell width-20">Address</td>
              <td class="value-cell" colspan="3">
                {{ person_details.permanent_address ? person_details.permanent_address.paddress : '' }}
              </td>
            </tr>
            <tr>
              <td class="label-cell">State</td>
              <td class="value-cell">{{ person_details.permanent_address ? person_details.permanent_address.pstate : '' }}</td>
              <td class="label-cell">District</td>
              <td class="value-cell">{{ person_details.permanent_address ? person_details.permanent_address.pdistrict : '' }}</td>
            </tr>
            <tr>
              <td class="label-cell">City/Town/Village</td>
              <td class="value-cell">{{ person_details.permanent_address ? person_details.permanent_address.pcity : '' }}</td>
              <td class="label-cell">Pincode</td>
              <td class="value-cell">{{ person_details.permanent_address ? person_details.permanent_address.ppin : '' }}</td>
            </tr>
          </table>
        </div>

        <div class="section-block">
          <div class="section-title">Contact Details</div>
          <table class="form-table details-table">
            <tr>
              <td class="label-cell width-20">Student Phone</td>
              <td class="value-cell width-30"></td>
              <td class="label-cell width-20">Parent Phone</td>
              <td class="value-cell width-30">{{ person_details.relative_father_details ? person_details.relative_father_details.relative_contact_no : '' }}</td>
            </tr>
            <tr>
              <td class="label-cell">Mobile</td>
              <td class="value-cell">{{ person_details.mobile_no }}</td>
              <td class="label-cell">Email Id</td>
              <td class="value-cell">{{ person_details.student_email ? person_details.student_email : person_details.personal_email }}</td>
            </tr>
          </table>
        </div>

        <div class="section-block" v-if="person_details.all_crs_des && Object.keys(person_details.all_crs_des).length > 0">
          <div class="section-title">Registered Subjects</div>
          <table class="form-table details-table">
            <tr class="sub-label-row">
              <td class="label-cell" style="width: 15%; text-align: center;">Code</td>
              <td class="label-cell" style="width: 85%; text-align: left; padding-left: 10px;">Subject Name</td>
            </tr>
            <tr v-for="(subjectName, subjectCode) in person_details.all_crs_des" :key="subjectCode">
              <td class="value-cell" style="text-align: center;"><b>{{ subjectCode }}</b></td>
              <td class="value-cell" style="padding-left: 10px;">{{ subjectName }}</td>
            </tr>
          </table>
        </div>

      </div>
      <div
        v-if="person_details.admission_instruction && person_details.admission_instruction.admission_instructions_html_code"
        class="dynamic-content-wrapper"
        ref="instructionsContainer"
      ></div>

      <!-- <div
        v-if="person_details.admission_instruction && person_details.admission_instruction.admission_checklist_html_code"
        class="dynamic-content-wrapper"
        ref="checklistContainer"
      ></div> -->

      <div class="text-center no-print" style="margin: 20px 0;">
        <v-btn tile outlined color="primary" @click="print()">
          <v-icon left>mdi-printer</v-icon> Print Form
        </v-btn>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: "AdmissionForm",
  props: ["person_details"],

  created() {
    this.awspath = localStorage.getItem("awspath") || "";
    this.tenant = localStorage.getItem("EPS-tenant") || "";
  },

  mounted() {
    this.$nextTick(() => {
      this.injectDynamicContent();
    });
  },

  updated() {
    this.$nextTick(() => {
      this.injectDynamicContent();
    });
  },

  methods: {
    print() {
      setTimeout(() => window.print(), 200);
    },

    injectDynamicContent() {
      const instr = this.person_details && this.person_details.admission_instruction;
      if (!instr) return;

      if (this.$refs.instructionsContainer && instr.admission_instructions_html_code) {
        this.$refs.instructionsContainer.innerHTML = instr.admission_instructions_html_code;
        this.activateStyles(this.$refs.instructionsContainer);
      }

      if (this.$refs.checklistContainer && instr.admission_checklist_html_code) {
        this.$refs.checklistContainer.innerHTML = instr.admission_checklist_html_code;
        this.activateStyles(this.$refs.checklistContainer);
      }
    },

    activateStyles(container) {
      const styles = container.querySelectorAll("style");
      styles.forEach((styleEl) => {
        const clone = document.createElement("style");
        clone.setAttribute("data-dynamic-admission", "true");
        clone.textContent = styleEl.textContent;
        document.head.appendChild(clone);
        styleEl.remove();
      });
    },
  },

  beforeDestroy() {
    document.querySelectorAll("style[data-dynamic-admission]").forEach(el => el.remove());
  },
};
</script>

<style scoped>
#one_view_form {
  width: 100%;
  max-width: 900px;
  margin: 0 auto;
  background: #fff;
  font-family: "Times New Roman", Times, serif;
  color: #000;
  line-height: 1.3;
}

.print-page {
  border: 2px solid #000;
  padding: 25px;
  margin-bottom: 25px;
  box-sizing: border-box;
  page-break-after: always;
  break-after: page;
  page-break-inside: avoid;
  break-inside: avoid;
  background: #fff;
}

.header-wrapper {
  margin-bottom: 15px;
}

.header-top-text {
  display: flex;
  justify-content: space-between;
  font-size: 13px;
  font-weight: bold;
  margin-bottom: 4px;
}

.header-table {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #000;
}

.header-table td {
  border: 1px solid #000;
  padding: 8px;
  vertical-align: middle;
}

.header-logo-cell {
  width: 12%;
  text-align: center;
}
.college-logo {
  max-width: 70px;
  height: auto;
}

.header-info-cell {
  width: 40%;
  text-align: center;
}
.college-name {
  font-size: 22px;
  font-weight: bold;
  margin: 0 0 5px 0;
  text-transform: uppercase;
}
.college-address {
  font-size: 13px;
}

.header-app-cell {
  width: 33%;
  text-align: left;
  padding-left: 15px !important;
}
.app-title { font-size: 13px; font-weight: bold; }
.app-standard { font-size: 16px; font-weight: bold; margin: 2px 0; }
.app-session { font-size: 13px; margin-bottom: 5px; }
.app-no { font-size: 13px; }

.header-photo-cell {
  width: 15%;
  text-align: center;
}
.student-photo {
  width: 90px;
  height: 110px;
  object-fit: cover;
  border: 1px solid #333;
}
.photo-placeholder {
  width: 90px;
  height: 110px;
  border: 1px solid #333;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #f9f9f9;
  font-size: 12px;
  color: #666;
}

.section-block {
  margin-bottom: -1px; /* collapse double borders */
}

.section-title {
  background: #e6e6e6;
  border: 1px solid #000;
  border-bottom: none;
  padding: 4px 8px;
  font-size: 14px;
  font-weight: bold;
}

.form-table {
  width: 100%;
  border-collapse: collapse;
}

.form-table td {
  border: 1px solid #000;
  padding: 5px 8px;
  font-size: 13px;
  vertical-align: middle;
}

.label-cell {
  font-weight: bold;
  background: #fcfcfc;
}
.value-cell {
  background: #fff;
}

.sub-label-row td {
  font-size: 11px;
  color: #333;
  text-align: center;
  padding: 2px 8px;
  background: #f4f4f4;
}

.split-cell {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
.split-cell span {
  width: 50%;
  text-align: center;
}

.width-15 { width: 15%; }
.width-20 { width: 20%; }
.width-30 { width: 30%; }
.width-35 { width: 35%; }

@media print {
  @page {
    size: A4 portrait;
    margin: 8mm 10mm;
  }

  .no-print, button, .v-btn, header, footer, nav {
    display: none !important;
  }

  html, body {
    margin: 0 !important;
    padding: 0 !important;
    background: #fff !important;
    color: #000 !important;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }

  #one_view_form {
    max-width: 100% !important;
    padding: 0 !important;
  }

  .print-page {
    margin: 0 0 0 0 !important; /* Margins handled by @page */
    box-shadow: none !important;
    border: 2px solid #000 !important; /* Explicitly enforce border on print */
  }
}

#one_view_form {
  width: 100%;
  max-width: 850px; /* Slightly narrower for better print margins */
  margin: 0 auto;
  font-family: "Times New Roman", Times, serif;
  color: #000;
}

.print-page {
  border: 2px solid #000;
  padding: 15px; /* Reduced padding to keep content on one page */
  box-sizing: border-box;
  page-break-after: always;
  background: #fff;
  min-height: 1000px; /* Forces height to occupy full A4 */
}

.header-table td {
  border: 1px solid #000;
  padding: 4px; /* Tighter padding */
}

.college-logo {
  max-width: 60px; /* Scaled down logo */
}

.section-block {
  margin-top: 5px;
}

.form-table td {
  border: 1px solid #000;
  padding: 3px 6px; /* Tightened cells for Page 1 fits */
  font-size: 12px;
}

@media print {
  @page { size: A4 portrait; margin: 5mm; }
  .print-page { border: 2px solid #000 !important; margin: 0 !important; }
  .no-print { display: none !important; }
}
</style>